import { Box, Button, Heading, Text, VStack } from "@chakra-ui/react"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Link from "@pathwright/ux/src/components/link/Link"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { useCertificateContext } from "../context/CertificateContext"
import { useUpdateResourceCertificateEnabled } from "../gating/DisabledResourceCertificateGate"
import CertificateAugmentationLayout from "../panel/CertificateAugmentationLayout"

export const CertificateCreatePrompt = () => {
  const { school } = usePathwrightContext()
  const { hasLegacyCertificate, resource } = useCertificateContext()

  const [enableResourceCertificate, enableState] =
    useUpdateResourceCertificateEnabled({
      enable: true
    })
  const [disableResourceCertificate, disableState] =
    useUpdateResourceCertificateEnabled({
      enable: false
    })

  return (
    <VStack gap={4} padding={4} textAlign="center">
      <Pathicon icon="edit" style={{ fontSize: "24px" }} />
      <Heading as="h3" size="xl">
        Offer Completion Certificates
      </Heading>
      <Text textAlign="center">
        Reward and document learner achievement by providing a custom-designed
        certificate of completion they can download or print when they reach the
        end of a Path.{" "}
        <Link
          textDecoration="underline"
          textUnderlineOffset={2}
          href="http://help.pathwright.com/en/articles/9211185-provide-a-certificate-of-completion"
        >
          Learn more about certificates.
        </Link>
      </Text>
      {hasLegacyCertificate && (
        <>
          <Heading as="h4" size="sm" mt={8}>
            Legacy Certificate
          </Heading>
          <Text textAlign="center">
            {school.name} currently uses the legacy certificate feature. You may
            create a new certifiacte, edit, and preview it while your learners
            continue to have access to the legacy certificate. Once you are
            ready,{" "}
            {window.Intercom ? (
              <Link
                textDecoration="underline"
                textUnderlineOffset={2}
                onClick={() => window.Intercom("showNewMessage")}
              >
                contact us
              </Link>
            ) : (
              <Link
                textDecoration="underline"
                textUnderlineOffset={2}
                href="mailto:hello@pathwright.com"
              >
                contact us
              </Link>
            )}{" "}
            to enable your new certificate.
          </Text>
          {resource &&
            (resource.has_certificate ? (
              <Button
                colorPalette="brand"
                variant="solid"
                size="md"
                onClick={() => disableResourceCertificate(resource)}
                loading={disableState.loading}
              >
                Disable Certificate
              </Button>
            ) : (
              <Button
                colorPalette="brand"
                variant="solid"
                size="md"
                onClick={() => enableResourceCertificate(resource)}
                loading={enableState.loading}
              >
                Enable Certificate
              </Button>
            ))}
        </>
      )}
    </VStack>
  )
}

const CertificateCreate = () => {
  return (
    <Box
      bg="whitesmoke"
      width="min(100vw, 792px)"
      minHeight="min(100vh, 612px)"
      position="relative"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="20px"
      m={2}
      textAlign="center"
    >
      <Box maxW="400px">
        <CertificateCreatePrompt />
      </Box>
    </Box>
  )
}

const CertificateCreator = () => (
  <CertificateAugmentationLayout Primary={CertificateCreate} />
)

CertificateCreator.displayName = "CertificateCreator"

export default CertificateCreator
